import React, { useRef } from "react"
import {
  Offcanvas as BSOffcanvas,
  OffcanvasProps as BSOffcanvasProps
} from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { useInertElement } from "shared/lib/useInertElement"
import { IconSize } from "shared/types/Icon"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface OffcanvasProps extends BSOffcanvasProps {
  children?: React.ReactNode
  headerSlot?: React.ReactNode
  inert?: boolean
  hideHeader?: boolean
}

export const Offcanvas = React.memo(
  ({
    children,
    inert,
    headerSlot,
    hideHeader = false,
    ...props
  }: OffcanvasProps) => {
    const { onHide } = props
    const { t } = useTranslation()
    const offCanvasRef = useRef<{ dialog?: HTMLElement } | undefined>(undefined)
    useInertElement({
      element: offCanvasRef.current?.dialog || null,
      condition: inert
    })

    return (
      <BSOffcanvas ref={offCanvasRef} {...props}>
        {hideHeader ? (
          <BSOffcanvas.Header>
            {headerSlot}
            <Button
              variant={ButtonVariant.TERTIARY}
              icon={IconName.CLOSE}
              isIconOnly
              onClick={onHide}
              label={t("General.Close")}
              iconSize={IconSize.MEDIUM}
              className="offcanvas__close-button"
            />
          </BSOffcanvas.Header>
        ) : null}
        <BSOffcanvas.Body>{children}</BSOffcanvas.Body>
      </BSOffcanvas>
    )
  }
)
